import type {Employee} from "$lib/types/employee";

export default function employeeComplete(employee: Employee):boolean {
    // plain
    if(!employee.firstName || !employee.lastName || !employee.maidenName || !employee.gender || !employee.mobile || !employee.status){
        return false;
    }
    // cv
    if(!employee.cv.nationality || !employee.cv.degree || !employee.cv.religiousAffiliation || !employee.cv.taxationClass
        || !employee.cv.height || !employee.cv.shoeSize|| !employee.cv.pantsSize|| !employee.cv.shirtSize|| !employee.cv.graduation
        || !employee.cv.familyStatus|| !employee.cv.placeOfBirth || !employee.cv.countryOfBirth
        || !employee.cv.hairColor){
        return false;
    }
    // insurance
    if(!employee.healthInsurance.insuranceName){
        return false;
    }
    // bank
    if(!employee.bankAccount.iban || !employee.bankAccount.accountName){
        return false;
    }
    return true;
}